import React, { useState } from 'react';
import TierHeader from './TierHeader';
import TierLegends from './TierLegends';
import { Collapse } from 'reactstrap';
import TierNode from './TierNode';
import { Framework, Tier2 } from 'src/shared/types/src';

const TierTwo = ({ _framework, expand }: { _framework: Framework, expand: boolean }) => {
  const [isVisible, setIsVisible] = useState(expand);
  const assessments = _framework.assessments as Tier2;

  return (
    <div className='framework-tier-wrap'>
      <TierHeader tierTitle={_framework.name} onClick={() => setIsVisible(!isVisible)} isVisible={isVisible} />
        <Collapse isOpen={isVisible}> 
          <div className='mg-t-10'>
            <TierLegends assessmentLevels={_framework.assessmentLevel} />
            <div className='mg-t-5'>
              { assessments?.areas?.map((areas: any, index: number) => 
                <TierNode content={areas.name} key={index} borderColor={areas.color} customLabelStyle={'fw-semibold'}>
                  {
                    areas?.statements?.map((statement: any, index: number) => 
                      <TierNode content={statement.name} label={statement.label} iconType={statement.iconType} key={index} borderColor={statement.color} isStatement={true}/>
                    )
                  }
                </TierNode>
              )}
            </div>
          </div>
        </Collapse>
    </div>
  );
};

export default TierTwo;
